import { StyledSimpleCard } from 'styles';
import { InitializeSubscriptionRealmForm } from 'RealmModule/components/SubscriptionRealm/InitializeSubscriptionRealmForm';

export const InitializeSubscriptionRealmCard = () => {
  return (
    <StyledSimpleCard>
      <InitializeSubscriptionRealmForm />
    </StyledSimpleCard>
  );
};
